import React from "react";
import MaskedInput from 'react-text-mask'

class PhoneInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    handleChange(e) {
        this.setState({
            value: e.target.value
        }, this.props.onChange.bind(null, e.target.value));
    }

    render() {
        return (
            <MaskedInput
                mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                className={this.props.classes.input}
                placeholder="Enter a phone number"
                guide={true}
                id={this.props.id}
                value={this.state.value}
                onChange={this.handleChange.bind(this)}
                onBlur={this.props.onBlur.bind(null, this.state.value)}
                onKeyDown={this.props.onKeyDown}
            />
        );
    }
};

PhoneInput.defaultProps = {
    classes: {},
    name: '',
    id: '',
    value: '',
    placeholder: '',
    onChange: () => {},
    onBlur: () => {},
    onKeyDown: () => {}
};

export default PhoneInput;